import React, { useEffect, useState } from 'react';
import { Layout } from '../../../components/layout/Layout';
import { PageHeader } from '../../../components/layout/PageHeader';
import { Card, CardContent } from '../../../components/ui/Card';
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from '../../../components/ui/Table';
import { Button } from '../../../components/ui/Button';
import { listEmailConfigs } from '../../../modules/comms/api/comms.gateway';
import { EmailProviderConfig } from '../../../modules/comms/types';
import { Spinner } from '../../../components/ui/Spinner';
import { showErrorToast } from '../../../utils/errorHandler';
import { EmailConfigModal } from './EmailConfigModal';

export const EmailProviderConfigsPage: React.FC = () => {
  const [configs, setConfigs] = useState<EmailProviderConfig[]>([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [editing, setEditing] = useState<EmailProviderConfig | null>(null);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const data = await listEmailConfigs();
        setConfigs(data || []);
      } catch (err) {
        showErrorToast(err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const refresh = async () => {
    setLoading(true);
    try {
      const data = await listEmailConfigs();
      setConfigs(data || []);
    } catch (err) {
      showErrorToast(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <PageHeader title="Email Provider Configs" subtitle="Manage email provider configurations" />
      <Card>
        <CardContent>
            <div className="flex justify-end mb-4">
            <Button onClick={() => { setEditing(null); setModalOpen(true); }}>Create</Button>
          </div>

          {loading ? (
            <div className="flex justify-center py-8"><Spinner size="lg" /></div>
          ) : configs.length === 0 ? (
            <div className="text-center py-8 text-gray-500">No email configs found.</div>
          ) : (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Display Name</TableHead>
                  <TableHead>Provider</TableHead>
                  <TableHead>Sender</TableHead>
                  <TableHead>Default</TableHead>
                  <TableHead>Actions</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {configs.map((cfg) => (
                  <TableRow key={cfg.id}>
                    <TableCell className="font-medium">{cfg.display_name}</TableCell>
                    <TableCell>{cfg.provider_type}</TableCell>
                    <TableCell>{cfg.sender_email}</TableCell>
                    <TableCell>{cfg.is_default ? 'Yes' : 'No'}</TableCell>
                    <TableCell>
                      <Button variant="ghost" size="sm" onClick={() => { setEditing(cfg); setModalOpen(true); }}>Edit</Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </CardContent>
      </Card>
      <EmailConfigModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        initial={editing}
        onSaved={refresh}
      />
    </Layout>
  );
};


